module.exports = __webpack_public_path__ + "media/assets/images/check_off-1fae48377b7717e0e0d0ff1b081097da.png";